module.exports = __webpack_public_path__ + "static/header-intro-d139b66dad7c519f78595b24984ab530.mp4";